import $ from 'jquery';
import slick from 'slick-carousel';

var $slickElement = $('[data-slick]');

// nav slider left
$( '.prev' ).on( 'click' , function( e ) {
  e.preventDefault();
  $slickElement.slick('slickPrev');
});

// nav slider right
$( '.next' ).on( 'click' , function( e ) {
  e.preventDefault();
  $slickElement.slick('slickNext');
});

// init slick
$slickElement.slick( {
  swipeToSlide: true,
  rows: 1,
  autoplay:true,
  autoplaySpeed: 5000,
} );
